<template>
	<div>Redirecting to payment provider...</div>
</template>
<script>
// import { App as NativeApp } from "@capacitor/app";
import appConfig from "../../appconfig";

export default {
	name: "RedirectHelper",
	async mounted() {
		const { returnUrl } = this.$route.query || {};
		if(returnUrl) {
			const isMobile = appConfig.mobile.isMobileApp();
			const baseUrl = isMobile ? appConfig.getPaymentUrl() : window.location.origin;
		
			// Open in in InAppBrowser tab
			if (isMobile) {
				let exitGracefully = false;
				const browserObjectModel = window.cordova ? window.cordova.InAppBrowser : window;
				let ref = browserObjectModel.open(
					returnUrl,
					"_blank",
					"location=no,toolbar=yes,zoom=no"
				);

				// In theory we are not going to another app, so this is commented out
				// const listener = await NativeApp.addListener("appUrlOpen", data => {
				// 	listener.remove();
				// 	if (data.url.startsWith(baseUrl) || data.url.startsWith(baseUrl)) {
				// 		exitGracefully = true;
				// 		ref.close();
				// 		this.$router.push(data.url.replace(baseUrl, ""));
				// 	}
				// });

				ref.addEventListener("exit", () => {
				// eslint-disable-next-line no-console
					console.log("exited");
					ref = null;
					if(!exitGracefully){
						this.$router.push("/");
					}
				});
				ref.addEventListener("loadstart", event => {
					if (event.url.startsWith(baseUrl)) {
						ref.close();
						this.$router.push(event.url.replace(baseUrl, ""));
						exitGracefully = true;
					}
				});

			} else {
				window.location.replace(returnUrl);
			}
		} else {
			this.$router.push("/");
		}
	}
};

</script>
